import { render, staticRenderFns } from "./StockTransaction.vue?vue&type=template&id=d9120fe8&"
import script from "./StockTransaction.vue?vue&type=script&lang=js&"
export * from "./StockTransaction.vue?vue&type=script&lang=js&"
import style0 from "./StockTransaction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports